import type { ReactNode } from "react";
import { Label } from "@/components/ui/label";
import { cn } from "@/lib/utils";

export type IntakeStatus = "idle" | "sending" | "error" | "unavailable";

export function IntakeField({
  id,
  label,
  error,
  className,
  children,
}: {
  id: string;
  label: string;
  error?: string | undefined;
  className?: string | undefined;
  children: ReactNode;
}) {
  return (
    <div className={cn("min-w-0", className)}>
      <Label htmlFor={id} className="text-[0.8rem] font-medium text-foreground">
        {label}
      </Label>
      <div className="mt-1.5">{children}</div>
      {error ? (
        <p id={`${id}-error`} role="alert" className="mt-1.5 text-xs text-destructive">
          {error}
        </p>
      ) : null}
    </div>
  );
}

export function IntakeSelect({
  id,
  options,
  error,
}: {
  id: string;
  options: readonly { value: string; label: string }[];
  error?: string | undefined;
}) {
  return (
    <select
      id={id}
      name={id}
      defaultValue=""
      required
      aria-invalid={!!error}
      aria-describedby={error ? `${id}-error` : undefined}
      className="h-9 w-full rounded-md border border-input bg-background px-3 text-sm text-foreground shadow-sm focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 focus-visible:ring-offset-background focus-visible:outline-none"
    >
      <option value="" disabled>
        -
      </option>
      {options.map((option) => (
        <option key={option.value} value={option.value}>
          {option.label}
        </option>
      ))}
    </select>
  );
}
